<template>
    <v-container grid-list-md fluid>
        <template wrap v-if="isAuthorized">
            <v-tabs
                v-model="activeTab"
                id="Devis"
                class="bg-white"
                style="border-radius: 16px; overflow: hidden"
            >
                <v-tab value="Operation" href="#Operation" data-cy="stocks-operation-tab"
                    >Opérations</v-tab
                >
                <v-tab value="Stock" href="#Stock" data-cy="stocks-stock-tab">Stock</v-tab>
                <v-tab value="Inventary" href="#Inventary" data-cy="stocks-inventary-tab"
                    >Inventaire</v-tab
                >
                <v-tab value="Product" href="#Product" data-cy="stocks-product-tab" id="Product"
                    >Produits</v-tab
                >
                <v-tab
                    value="StockAssessment"
                    href="#StockAssessment"
                    data-cy="stocks-operation-tab"
                    >Centres d'analyse</v-tab
                >
                <v-tab
                    value="SalesMargin"
                    href="#SalesMargin"
                    data-cy="stocks-sales-margin-tab"
                    id="SalesMargin"
                    >Marges sur ventes</v-tab
                >
            </v-tabs>
            <v-tabs-window v-model="activeTab" style="background-color: transparent !important">
                <v-tabs-window-item key="Operation" value="Operation">
                    <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                        <v-col cols="2" class="pr-1">
                            <v-btn-primary
                                block
                                @click="openOperationDialog('INPUT')"
                                data-cy="stocks-new-input-operation"
                            >
                                Ajouter
                            </v-btn-primary>
                        </v-col>
                        <v-col cols="2" class="pl-2">
                            <v-btn-primary
                                block
                                @click="openOperationDialog('OUTPUT')"
                                data-cy="stocks-new-output-operation"
                            >
                                Retirer
                            </v-btn-primary>
                        </v-col>
                        <v-col cols="2" class="pl-2">
                            <v-btn-primary
                                block
                                @click="computeStockOperation"
                                data-cy="stocks-compute-operation"
                                :loading="computeStockOperationLoading"
                            >
                                Calculer
                            </v-btn-primary>
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-text-field
                                v-model="search"
                                append-inner-icon="$fa-search"
                                clearable
                                @click:clear="search = ''"
                                label="Recherche"
                                regular
                                outlined
                                hide-details
                                autofocus
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-data-table-server
                        :headers="operationHeaders"
                        :items="stockOperations"
                        v-model:page="operationPagination.page"
                        v-model:items-per-page="operationPagination.rowsPerPage"
                        v-model:items-length="operationPagination.totalItems"
                        :items-per-page-options="itemsPerPageOptions"
                        v-model:sort-by="operationPagination.sortBy"
                        :loading="stockLoading"
                        class="table"
                        fixed-header
                        max-height="60vh"
                        :multi-sort="false"
                    >
                        <template v-slot:item="{ item }">
                            <tr @click="editOperation(item)" style="cursor: pointer">
                                <td>{{ item.title || "-" }}</td>
                                <td class="text-center">
                                    <v-chip v-if="item.tagName" label size="x-small">{{
                                        item.tagName
                                    }}</v-chip>
                                </td>
                                <td class="text-center">
                                    {{ getOperationType(item.productQuantity) }}
                                </td>
                                <td class="text-center">{{ formatDate(item.date) }}</td>
                                <td class="text-center">
                                    <span v-if="item.stockProduct">{{
                                        getProductQuantityText(
                                            item.stockProduct,
                                            item.productQuantity,
                                        )
                                    }}</span>
                                </td>
                                <td class="text-center">
                                    {{ item.quantity ? Math.abs(item.quantity) : "" }}
                                </td>
                                <td class="text-center">
                                    {{
                                        item.productQuantity > 0
                                            ? newCommonFormatCurrency(item.price, undefined)
                                            : ""
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        item.productQuantity > 0
                                            ? newCommonFormatCurrency(item.unitPrice, undefined)
                                            : ""
                                    }}
                                </td>
                                <td class="text-center" @click.stop="openDocument(item)">
                                    <v-icon
                                        v-if="!!getDocumentId(item)"
                                        icon="$oss-file"
                                        color="blue"
                                        size="small"
                                    />
                                </td>
                            </tr>
                            <template v-if="item.children && item.children.length">
                                <template
                                    v-for="(child, index) in item.children"
                                    :key="item.id + '-' + index"
                                >
                                    <tr @click="editOperation(child)" style="cursor: pointer">
                                        <td>
                                            <v-icon
                                                icon="$subdirectory_arrow_right"
                                                style="margin-left: 8px; margin-right: 8px"
                                            />
                                            {{ child.title || "-" }}
                                        </td>
                                        <td class="text-center">
                                            <v-chip v-if="child.tagName" label size="x-small">{{
                                                child.tagName
                                            }}</v-chip>
                                        </td>
                                        <td class="text-center">
                                            {{ getOperationType(child.quantity) }}
                                        </td>
                                        <td class="text-center">{{ formatDate(child.date) }}</td>
                                        <td class="text-center">
                                            {{ child.productQuantityDisplay }}
                                        </td>
                                        <td class="text-center">
                                            {{ child.quantity ? Math.abs(child.quantity) : "" }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                child.quantity > 0
                                                    ? newCommonFormatCurrency(
                                                          child.price,
                                                          undefined,
                                                      )
                                                    : ""
                                            }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                child.quantity > 0
                                                    ? newCommonFormatCurrency(
                                                          child.unitPrice,
                                                          undefined,
                                                      )
                                                    : ""
                                            }}
                                        </td>
                                        <td class="text-center" />
                                    </tr>
                                    <template v-if="child.children && child.children.length">
                                        <tr
                                            v-for="(childChild, index2) in child.children"
                                            :key="item.id + '-' + index + '-' + index2"
                                            @click="editOperation(childChild)"
                                            style="cursor: pointer"
                                        >
                                            <td>
                                                <v-icon
                                                    icon="$subdirectory_arrow_right"
                                                    style="margin-left: 16px; margin-right: 8px"
                                                />
                                                {{ childChild.title || "-" }}
                                            </td>
                                            <td class="text-center">
                                                <v-chip
                                                    v-if="childChild.tagName"
                                                    label
                                                    size="x-small"
                                                    >{{ childChild.tagName }}</v-chip
                                                >
                                            </td>
                                            <td class="text-center">
                                                {{ getOperationType(childChild.quantity) }}
                                            </td>
                                            <td class="text-center">
                                                {{ formatDate(childChild.date) }}
                                            </td>
                                            <td class="text-center">
                                                {{ childChild.productQuantityDisplay }}
                                            </td>
                                            <td class="text-center">
                                                {{
                                                    childChild.quantity
                                                        ? Math.abs(childChild.quantity)
                                                        : ""
                                                }}
                                            </td>
                                            <td class="text-center">
                                                {{
                                                    childChild.quantity > 0
                                                        ? newCommonFormatCurrency(
                                                              childChild.price,
                                                              undefined,
                                                          )
                                                        : ""
                                                }}
                                            </td>
                                            <td class="text-center">
                                                {{
                                                    childChild.quantity > 0
                                                        ? newCommonFormatCurrency(
                                                              childChild.unitPrice,
                                                              undefined,
                                                          )
                                                        : ""
                                                }}
                                            </td>
                                            <td class="text-center" />
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </v-data-table-server>
                </v-tabs-window-item>
                <v-tabs-window-item key="Stock" value="Stock">
                    <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                        <v-switch class="pl-4" v-model="isFIFO" label="FIFO" hide-details inset />
                    </v-row>
                    <v-data-table
                        :headers="stockHeaders"
                        :items="stockItems"
                        :loading="stockLoading"
                        class="table"
                        fixed-header
                        max-height="60vh"
                        :multi-sort="false"
                    >
                        <template v-slot:item="{ item }">
                            <tr :class="item.available > 0 ? '' : 'error'">
                                <td>{{ item.title || "-" }}</td>
                                <td>{{ item.reference || "-" }}</td>
                                <td class="text-center">{{ mathFix(item.acquired, 3) || "0" }}</td>
                                <td class="text-center">
                                    {{ newCommonFormatCurrency(item.acquiredPrice, undefined) }}
                                </td>
                                <td class="text-center">{{ mathFix(item.consumed, 3) || "0" }}</td>
                                <td class="text-center">
                                    {{ newCommonFormatCurrency(item.consumedPrice, undefined) }}
                                </td>
                                <td class="text-center">
                                    {{ newCommonFormatCurrency(item.consumedUnitPrice, undefined) }}
                                </td>
                                <td class="text-center">{{ mathFix(item.available, 3) || "0" }}</td>
                                <td class="text-center">
                                    {{ newCommonFormatCurrency(item.residualPrice, undefined) }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-tabs-window-item>
                <v-tabs-window-item key="Inventary" value="Inventary">
                    <InventoryEditWizard :step="0" ref="invoiceEditWizard" />
                </v-tabs-window-item>
                <v-tabs-window-item key="Product" value="Product">
                    <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                        <v-col cols="2" class="px-2">
                            <v-btn-primary
                                block
                                @click="
                                    productDialog = true;
                                    productId = '';
                                "
                                data-cy="stocks-new-product"
                            >
                                Nouveau produit
                            </v-btn-primary>
                        </v-col>
                        <v-col cols="2" class="px-2">
                            <v-btn-primary
                                block
                                @click="importProductsDialog = true"
                                data-cy="stocks-new-product"
                            >
                                Importer produits
                            </v-btn-primary>
                        </v-col>
                    </v-row>
                    <v-data-table-server
                        :headers="productHeaders"
                        :items="products"
                        v-model:page="productPagination.page"
                        v-model:items-per-page="productPagination.rowsPerPage"
                        v-model:items-length="productPagination.totalItems"
                        :items-per-page-options="itemsPerPageOptions"
                        v-model:sort-by="productPagination.sortBy"
                        :loading="productLoading"
                        class="table"
                        fixed-header
                        max-height="60vh"
                        :multi-sort="false"
                    >
                        <template v-slot:item="{ item }">
                            <tr data-cy="stocks-product" @click="editProduct(item)">
                                <td>{{ item.reference }}</td>
                                <td>
                                    <v-chip v-if="item.tag" label size="x-small" :ripple="false">
                                        {{ item.tag.name }}
                                    </v-chip>
                                    {{ item.title }}
                                </td>
                                <td>{{ getType(item.type) }}</td>
                                <td>{{ newCommonFormatCurrency(item.unitPrice, undefined) }}</td>
                                <td>{{ getSymbolData(item).text }}</td>
                                <td>
                                    <v-switch
                                        v-model="item.outDated"
                                        inset
                                        color="primary"
                                        density="compact"
                                        hide-details
                                        @click.stop="setOutDatedProduct(item)"
                                    />
                                </td>
                            </tr>
                        </template>
                    </v-data-table-server>
                </v-tabs-window-item>
                <v-tabs-window-item key="StockAssessment" value="StockAssessment">
                    <StockAssessment :companyId="selectedCompany.id" />
                </v-tabs-window-item>
                <v-tabs-window-item key="SalesMargin" value="SalesMargin">
                    <SalesMargin :companyId="selectedCompany.id" />
                </v-tabs-window-item>
            </v-tabs-window>
        </template>
        <oss-dialog
            persistent
            v-model="operationDialog"
            :fullscreen="$vuetify.display.mobile"
            :title="operationTitle"
            :actions="actions"
            v-if="operationDialog"
            width="55vw"
        >
            <StockOperationEdition
                :id="stockOperationId"
                :type="operationType"
                :companyId="companyId"
                :actions="actions"
                @operation-saved="onOperationSaved"
            />
        </oss-dialog>
        <oss-dialog
            persistent
            v-model="inventoryDialog"
            :max-width="!$vuetify.display.mobile ? '900px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            title="Création d'un Inventaire"
            :actions="actions"
            v-if="inventoryDialog"
        >
        </oss-dialog>
        <oss-dialog
            persistent
            v-model="productDialog"
            :max-width="!$vuetify.display.mobile ? '1050px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            :title="productId ? 'Modification d\'un produit' : 'Création d\'un produit'"
            :actions="productActions"
            v-if="productDialog"
        >
            <CreateInvoiceProduct
                :id="productId"
                :companyId="companyId"
                :actions="productActions"
                :stock="true"
                @product-saved="onProductSaved"
            />
        </oss-dialog>
        <oss-dialog
            v-model="importProductsDialog"
            :minWidth="width"
            title="Importez vos produits"
            :actions="importActions"
            v-if="importProductsDialog"
        >
            <InvoiceProductImport
                v-if="importProductsDialog"
                ref="importComponent"
                :documentType="'STOCK_PRODUCTS'"
                :actions="importActions"
                :selectedCompanyId="selectedCompany.id"
                @documentImported="onDocumentImported()"
                @width="changeWidth()"
            />
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import gql from "graphql-tag";
import moment from "moment-timezone";
import Editor from "../../components/editorMenu/Editor.vue";

import { Apollo } from "@/decorators";

import { NotificationBase } from "../NotificationBase";
import OssFilterBar from "../ossComponents/ossFilterBar.vue";

import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { DialogAction } from "../../services/dialogAction";

import InvoiceProductImport from "../import/InvoiceProductImport.vue";
import CreateInvoiceProduct from "../invoice/CreateInvoiceProduct.vue";
import InventoryEditWizard from "./InventoryWizard.vue";
import SalesMargin from "./SalesMargins.vue";
import StockAssessment from "./StockAssessment.vue";
import StockOperationEdition from "./StockOperationEdition.vue";

import CUSTOMER_COMPANIES from "../../graphql/company/CustomerCompanies.gql";
import COMPUTE_STOCK_OPERATION from "../../graphql/stock/ComputeStockOperation.gql";
import STOCK_BALANCE from "../../graphql/stock/StockBalance.gql";

import { Component, Watch, toNative } from "vue-facing-decorator";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import {
    getProductQuantityText,
    getSymbolData,
} from "../../../../backend/src/common/stock/invoiceProductServices";
import { checkAccessRights } from "../../services/accessRightServices";
import { emailPattern } from "../../services/emailServices";
import { mathFix } from "../../services/mathServices";

class StockOperation {
    stockProduct;
    productFamily;
    productQuantity;
    quantity;
    constructor() {}
    get title() {
        if (this.stockProduct?.title) {
            return this.stockProduct.title;
        }
        if (this.productFamily) {
            return this.productFamily.name;
        }
        return "XXX";
    }
    get tagName() {
        if (this.stockProduct?.tag) {
            return this.stockProduct.tag.name;
        }
        if (this.productFamily) {
            return this.productFamily.name;
        }
        return "XXX";
    }

    get productQuantityDisplay() {
        if (this.stockProduct) {
            return getSymbolData(this.stockProduct, this.quantity).text;
        }
        return this.productQuantity;
    }
}

@Component({
    components: {
        Editor,
        OssFilterBar,
        CreateInvoiceProduct,
        StockOperationEdition,
        InventoryEditWizard,
        StockAssessment,
        SalesMargin,
        InvoiceProductImport,
    },
    emits: ["refresh", "update"],
})
export class StockTable extends NotificationBase {
    @State2Way("updateStockSearch", "stockFilter.search")
    search!: string;

    @State2Way("updateStockClientCompaniesSelected", "stockFilter.clientCompaniesSelected")
    clientCompaniesSelected: any[];

    @State2Way("updateStockOperationPagination", "stockFilter.operationPagination")
    operationPagination!: any;

    @State2Way("updateStockPagination", "stockFilter.stockPagination")
    stockPagination!: any;

    @State2Way("updateInventoryPagination", "stockFilter.inventoryPagination")
    inventoryPagination!: any;

    @State2Way("updateStockProductPagination", "stockFilter.productPagination")
    productPagination!: any;

    isFIFO = true;
    operationDialog = false;
    operationType = "";
    accountableAccountSelected = "";

    stockLoading = false;
    inventoryLoading = false;
    productLoading = false;

    productId = "";
    stockOperationId = "";

    productActions = {
        action: new DialogAction(),
    };

    importActions = {
        action: new DialogAction(),
    };

    actions = {
        action: new DialogAction(),
    };

    get rules() {
        return {
            isEmail: (value) => {
                return emailPattern.test(value) || "E-mail invalide";
            },
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
        };
    }

    get isVatSubject() {
        // debugger
        return !isNotSubjectToVAT(this.selectedCompany.vatSystem);
    }

    get operationHeaders(): {
        title: string;
        value: string;
        sortable?: boolean;
        align?: "start" | "center" | "end";
        width?: string;
    }[] {
        return [
            { title: "Produit", value: "product", sortable: false, align: "start", width: "30%" },
            { title: "Etiquette", value: "tag", sortable: false, align: "center" },
            { title: "Opération", value: "type", sortable: true, align: "center" },
            { title: "Date", value: "date", sortable: true, align: "center" },
            {
                title: "Quantité de produit(s)",
                value: "productQuantity",
                sortable: true,
                align: "center",
            },
            { title: "Quantité", value: "quantity", sortable: true, align: "center" },
            { title: "Coût", value: "price", sortable: true, align: "center" },
            { title: "Coût Unitaire", value: "unitPrice", sortable: false, align: "center" },
            { title: "", value: "document", sortable: true, align: "center" },
        ];
    }

    get productHeaders(): {
        title: string;
        value: string;
        sortable?: boolean;
        align?: "start" | "center" | "end";
        width?: string;
    }[] {
        return [
            { title: "Référence", value: "reference" },
            { title: "Titre", value: "title" },
            { title: "Type", value: "type" },
            { title: "Prix unitaire", value: "unitPrice" },
            { title: "Unité de mesure", value: "quantity" },
            { title: "Obsolète", value: "outDated", sortable: false },
        ];
    }

    get stockHeaders(): {
        title: string;
        value: string;
        sortable?: boolean;
        align?: "start" | "center" | "end";
        width?: string;
    }[] {
        return [
            { title: "Produit", value: "product", width: "20%", sortable: true },
            { title: "Référence", value: "reference", sortable: true },
            { title: "Acquis", value: "acquired", sortable: false, align: "center" },
            {
                title: "Coût direct/d'achat",
                value: "acquiredPrice",
                sortable: false,
                align: "center",
            },
            { title: "Consommé", value: "consumed", sortable: false, align: "center" },
            { title: "Valeur consommée", value: "consumedPrice", sortable: false, align: "center" },
            {
                title: "Coût unitaire consommé",
                value: "consumedUnitPrice",
                sortable: false,
                align: "center",
            },
            { title: "Disponible", value: "available", sortable: true, align: "center" },
            {
                title: "Valeur résiduelle",
                value: "availablePrice",
                sortable: false,
                align: "center",
            },
        ];
    }

    get itemsPerPageOptions() {
        return [
            { value: 10, title: "10" },
            { value: 25, title: "25" },
            { value: 50, title: "50" },
        ];
    }

    get statusList() {
        return [
            { text: "Tous", value: "ALL" },
            { text: "Projet", value: "DRAFT" },
            { text: "En cours de validation", value: "BEING_VALIDATED" },
            { text: "Validé", value: "VALIDATED" },
        ];
    }

    // get statusList() {
    //     return [
    //         { value: "ALL", text: "Tous"  },
    //         { value: 'DRAFT', text: (this.$t('stock.DRAFT') as string) },
    //         { value: 'BEING_VALIDATED', text: (this.$t('stock.BEING_VALIDATED') as string) },
    //         { value: 'VALIDATED', text: (this.$t('stock.VALIDATED') as string) },
    //         { value: 'ACCEPTED', text: (this.$t('stock.ACCEPTED') as string) },
    //         // { value: 'PAID', text: (this.$t('invoice.PAID') as string) },
    //     ]
    // }

    status = "ALL";

    productDialog = false;
    inventoryDialog = false;
    importProductsDialog = false;

    // formProduct = {
    //     id: null,
    //     title: '',
    //     unitPrice: 1,
    //     vatRate: 20
    // }

    savingProduct = false;

    @State2Way("updateStockActiveTab", "stock.activeTab")
    activeTab!: string;

    beforeMount() {
        if (this.$route.params.activeTab) {
            this.activeTab = this.$route.params.activeTab as string;
        }
        this.addListener("stock");
    }

    beforeDestroy() {
        this.removeListener();
    }

    get companyId() {
        // debugger
        return this.$store.state.selected_company.id;
    }

    get selectedCompany() {
        // debugger
        return this.$store.state.selected_company;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "stock", "read");
        return authorized;
    }

    get currentUser() {
        return this.$store.state.user;
    }

    _formatOrderBy(pagination) {
        const fieldName =
            pagination.sortBy?.length && pagination.sortBy[0].key
                ? pagination.sortBy[0].key
                : undefined;
        if (!fieldName) return undefined;

        const order =
            pagination.sortBy?.length && pagination.sortBy[0].order
                ? pagination.sortBy[0].order
                : undefined;
        if (!order) return undefined;
        return `${fieldName}_${order.toUpperCase()}`;
    }

    formatOrderByOperation() {
        return this._formatOrderBy(this.operationPagination);
    }

    formatOrderByStock() {
        return this._formatOrderBy(this.stockPagination);
    }

    formatOrderByInventory() {
        return this._formatOrderBy(this.inventoryPagination);
    }

    formatOrderByProducts() {
        return this._formatOrderBy(this.productPagination);
    }

    getOperationType(quantity) {
        return quantity > 0 ? "Entrée" : "Sortie";
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    mathFix(value, dec) {
        return mathFix(value, dec);
    }

    getType(type) {
        if (type === "PRODUCT") {
            return "Produit";
        } else if (type === "EXPENSE") {
            return "Achat";
        }
        return "";
    }

    @Apollo({
        query: gql`
            query Products(
                $companyId: ID!
                $first: Int!
                $skip: Int!
                $search: String
                $orderBy: InvoiceProductOrderByInput
                $stock: Boolean!
            ) {
                invoiceProducts(
                    where: {
                        company: { id: $companyId }
                        title_contains: $search
                        stock: $stock
                        # outDated_not: true
                    }
                    first: $first
                    skip: $skip
                    orderBy: $orderBy
                ) {
                    id
                    reference
                    title
                    unitPrice
                    outDated
                    type
                    family
                    tag {
                        id
                        name
                    }
                    quantityType
                    unitQuantity
                    quantityName
                }
                invoiceProductsConnection(
                    where: { company: { id: $companyId }, title_contains: $search, stock: $stock }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            this.productLoading = true;
            return {
                stock: true,
                companyId: this.companyId,
                first: this.productPagination.rowsPerPage,
                skip: (this.productPagination.page - 1) * this.productPagination.rowsPerPage,
                search: this.search.length > 0 ? this.search : undefined,
                orderBy: this.formatOrderByProducts(),
            };
        },
        skip() {
            return !this.companyId || !this.isAuthorized;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.productLoading = false;
                // console.log(data)
                if (data.invoiceProductsConnection && data.invoiceProductsConnection.aggregate) {
                    this.productPagination.totalItems =
                        data.invoiceProductsConnection.aggregate.count;
                }
                for (const p of data.invoiceProducts) {
                    if (p.outDated === null) {
                        p.outDated = true;
                    }
                }
                this.products = data.invoiceProducts.sort(function (x, y) {
                    return x.outDated === y.outDated ? 0 : x.outDated ? 1 : -1;
                });
                // debugger
            }
        },
    })
    products = [];

    @Apollo({
        query: gql`
            query Operations(
                $companyId: ID!
                $first: Int!
                $skip: Int!
                $search: String
                $orderBy: StockOperationOrderByInput
            ) {
                stockOperations(
                    where: {
                        company: { id: $companyId }
                        stockProduct: { title_contains: $search }
                        parent: null
                    }
                    first: $first
                    skip: $skip
                    orderBy: $orderBy
                ) {
                    id
                    type
                    price
                    date
                    unitPrice
                    quantity
                    productQuantity
                    stockProduct {
                        id
                        title
                        tag {
                            id
                            name
                        }
                        quantityType
                        unitQuantity
                        quantityName
                    }
                    productFamily {
                        id
                        name
                    }

                    children {
                        id
                        type
                        price
                        date
                        unitPrice
                        quantity
                        productQuantity
                        stockProduct {
                            id
                            title
                            tag {
                                id
                                name
                            }
                            quantityType
                            unitQuantity
                            quantityName
                        }
                        productFamily {
                            id
                            name
                        }

                        children {
                            id
                            type
                            price
                            date
                            unitPrice
                            quantity
                            productQuantity
                            stockProduct {
                                id
                                title
                                tag {
                                    id
                                    name
                                }
                                quantityType
                                unitQuantity
                                quantityName
                            }
                            productFamily {
                                id
                                name
                            }
                        }
                    }

                    document {
                        id
                        invoice {
                            id
                        }
                    }
                    accountingLine {
                        id
                        document {
                            id
                            invoice {
                                id
                            }
                        }
                    }
                }
                stockOperationsConnection(
                    where: {
                        company: { id: $companyId }
                        stockProduct: { title_contains: $search }
                        parent: null
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            this.stockLoading = true;
            return {
                companyId: this.companyId,
                first: this.operationPagination.rowsPerPage,
                skip: (this.operationPagination.page - 1) * this.operationPagination.rowsPerPage,
                search: this.search.length > 0 ? this.search : undefined,
                orderBy: this.formatOrderByOperation(),
            };
        },
        skip() {
            return !this.companyId || !this.isAuthorized;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                // debugger
                this.stockLoading = false;
                // console.log(data)
                if (data.stockOperationsConnection && data.stockOperationsConnection.aggregate) {
                    this.operationPagination.totalItems =
                        data.stockOperationsConnection.aggregate.count;
                }

                const stockOperations = [];
                for (const so of data.stockOperations) {
                    if (so.children?.length) {
                        const children = [];
                        for (const child of so.children) {
                            const childObj = Object.assign(new StockOperation(), child, {});
                            children.push(childObj);
                            if (child.children?.length) {
                                const childChildren = [];
                                for (const childChild of child.children) {
                                    childChildren.push(
                                        Object.assign(new StockOperation(), childChild, {}),
                                    );
                                }
                                childObj.children = childChildren;
                            }
                        }
                        so.children = children;
                    }
                    stockOperations.push(Object.assign(new StockOperation(), so, {}));
                }
                // this.accountingLines = accountingLines
                this.stockOperations = stockOperations;
            }
        },
    })
    stockOperations = [];

    @Apollo({
        query: STOCK_BALANCE,
        variables() {
            return {
                selectedCompanyId: this.companyId,
                productId: "",
                method: this.isFIFO ? "FIFO" : "WEIGHTED",
            };
        },
        skip() {
            return !this.companyId || !this.isAuthorized;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                // debugger
                if (data && data.stockBalance) {
                    this.stockItems = data.stockBalance.stocks;
                }
            }
        },
    })
    stockItems = [];

    @Apollo({
        query: CUSTOMER_COMPANIES,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
    })
    customerCompanies: Array<any> = [];

    // @Apollo({
    //     query: gql `query CompanyQuery($companyId: ID!) {
    //         company(
    //             where: {
    //                 id: $companyId
    //             }
    //         ){
    //             id
    //             name
    //             profile { id sendingMailSMTPConfig }
    //         }
    //     }`,
    //     variables() {
    //         return {
    //             companyId: this.$store.state.selected_company.id,
    //         }
    //     },
    //     skip() {
    //         return !this.$store.state.selected_company.id
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data && data.company && data.company.profile && data.company.profile.sendingMailSMTPConfig) {
    //                 this.credentialsEmailAddresses = JSON.parse(JSON.stringify(data.company.profile.sendingMailSMTPConfig.users));
    //                 this.credentialsEmailAddresses.push({ email: "Utiliser l'adresse mail de bobbee" })
    //                 if (this.credentialsEmailAddresses.length) {
    //                     this.mailAddressSender = this.credentialsEmailAddresses[0].email
    //                 }
    //             } else {
    //                 this.credentialsEmailAddresses = [{
    //                     email: "Utiliser l'adresse mail de bobbee",
    //                 }]
    //                 this.mailAddressSender = "Utiliser l'adresse mail de bobbee"
    //                 // console.log("AccountableAccountVue data pb");
    //                 // this.thirdPartyAccountableAccounts.splice(0, this.thirdPartyAccountableAccounts.length);
    //             }
    //         }
    //     }
    // })
    // credentialsEmailAddresses: Array<any> = [];

    formatDate(date: Date) {
        if (!date) return "-";
        return moment(date).format("DD/MM/YYYY");
    }

    get operationTitle() {
        if (!this.stockOperationId) {
            return this.operationType === "INPUT" ? "Ajouter au stock" : "Retirer du stock";
        }
        let title = "Modifier l'opération de Stock";
        // if (this.operationType === "INPUT") {
        //     title += " (Entrée)"
        // } else if (this.operationType === "OUTPUT") {
        //     title += " (Sortie)"
        // }
        return title;
    }

    openOperationDialog(type) {
        this.operationDialog = true;
        this.operationType = type;
        this.stockOperationId = "";
        // this.operationTitle = type === 'INPUT' ?  "Ajouter au stock" : "Retirer du stock";
    }

    editOperation(o) {
        this.stockOperationId = o.id;
        this.operationDialog = true;
        // this.operationTitle = 'Modifier l\'opération de Stock'
    }

    editProduct(p) {
        this.productId = p.id;
        this.productDialog = true;
    }

    clearFilter() {
        this.clientCompaniesSelected = [];
        this.search = "";
    }

    onOperationSaved() {
        this.operationDialog = false;
        this.operationType = "";
        if (this.$apollo.queries.stockOperations) {
            this.$apollo.queries.stockOperations.refetch();
        }
        if (this.$apollo.queries.stockItems) {
            this.$apollo.queries.stockItems.refetch();
        }
        this.productId = "";
    }

    onProductSaved() {
        this.productDialog = false;
        if (this.$apollo.queries.products) {
            this.$apollo.queries.products.refetch();
        }
        this.productId = "";
    }

    setThirdPartyCompanyName(thirdPartyCompanyName: string) {
        this.clientCompaniesSelected = [
            this.customerCompanies.find((c) => c.name === thirdPartyCompanyName).id,
        ];
    }

    async setOutDatedProduct(item) {
        // debugger
        await this.$apollo.mutate({
            mutation: gql`
                mutation outDatedProduct($id: ID!, $outDated: Boolean!) {
                    updateInvoiceProduct(where: { id: $id }, data: { outDated: $outDated }) {
                        id
                    }
                }
            `,
            variables: {
                id: item.id,
                outDated: item.outDated,
            },
        });
        // this.products.filter(x => x.id !== id)
    }

    onDocumentImported() {
        this.onProductSaved();
        this.importProductsDialog = false;
        this.$emit("refresh");
    }

    @Watch("operationDialog")
    reset() {
        if (this.$refs.stockOperationEdition) {
            // @ts-ignore
            this.$refs.stockOperationEdition.reset();
        }
    }

    @Watch("companyId")
    resetPagination() {
        this.operationPagination.page = 1;
        this.stockPagination.page = 1;
        this.productPagination.page = 1;
        this.inventoryPagination.page = 1;
    }

    @Watch("clientCompaniesSelected")
    test() {
        debugger;
        this.clientCompaniesSelected;
    }

    @Watch("isFIFO")
    changeMethod() {
        this.$emit("update");
    }

    getDocumentId(stockOperation) {
        return stockOperation.document?.id || stockOperation.accountingLine?.document?.id;
    }

    openDocument(stockOperation) {
        const documentId = this.getDocumentId(stockOperation);
        if (documentId) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.selectedCompany.id,
                    id: documentId,
                },
            });
        }
    }

    // onMessageCheckList(data, list) {
    //     if (data.action === "update") {
    //         let index = list.findIndex(aie => aie.id === data.id)
    //         if (index !== -1) {
    //             if (data.payload && data.extraPayload) {
    //                 data.payload.extraData = data.extraPayload
    //             }
    //             this.stocks.splice(index, 1, data.payload)
    //             return true
    //         }

    //     } else if (data.action === "delete" ) {
    //         const index = this.stocks.findIndex(aie => aie.id === data.id)
    //         if (index !== -1) {
    //             this.stocks.splice(index, 1)
    //             return true
    //         }
    //     }
    //     return false
    // }

    // onMessage(data) {
    //     console.log("on message stocks")
    //     if (data) {
    //         if (data.action === "create") {
    //             // nothing to do
    //         }
    //         if (!this.onMessageCheckList(data, this.stocks)) {
    //             if (!this.onMessageCheckList(data, this.billOfDelivery)) {
    //                 this.onMessageCheckList(data,this.quotations)
    //             }
    //         }
    //     }
    // }

    getSymbolData(product, quantity: number = 1) {
        return getSymbolData(product, Math.abs(quantity));
    }

    getProductQuantityText(product, productQuantity: number = 1) {
        return getProductQuantityText(product, Math.abs(productQuantity));
    }

    //
    //
    //
    computeStockOperationLoading: boolean = false;

    async computeStockOperation() {
        // debugger
        this.computeStockOperationLoading = true;

        await this.$apollo.mutate({
            mutation: COMPUTE_STOCK_OPERATION,
            variables: {
                companyId: this.companyId,
            },
        });
        this.refresh();
        this.computeStockOperationLoading = false;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.stockOperations) {
            this.$apollo.queries.stockOperations.refetch();
        } else {
            debugger;
        }
    }

    width = "50%";
    changeWidth() {
        //@ts-ignore
        if (this.$refs.importComponent?.step !== 0) {
            this.width = "75%";
        } else {
            this.width = "60%";
        }
    }
}

export default toNative(StockTable);
</script>
